const searchParams = {
  "useScroll": false,
  "expreType": 1,
  "modelId": "75c3b76f-1cb9-11eb-b1c6-70106fc9fcee",
  "offset": 0,
  "queryId": null,
  "requestCols": [{
    "alias": "high_quality_score"
    },
    {
      "alias": "high_technical_score"
    },
    {
      "alias": "high_economy_score"
    },
    {
      "alias": "development_score"
    }, 
    {
      "alias": "patent_value_score"
    }
  ],
  "pageSize": 100,
  "translation": false,
  "includeLabels": [],
  "excludeLabels": [],
  "searchExpre": "",
  "mergeType": 0,
  "conditions": [],
  "searchNew": false,
  "batchSearch": false,
  "search": true
}

module.exports = {
  searchParams
}